import { createRoot } from 'react-dom/client';
import { App } from './App';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(<App />);

const registerServiceWorker = async () => {
  const registration = await navigator.serviceWorker.getRegistration();
  if (registration) {
    // Force an update check
    await registration.update().then(() => {
      console.debug('Service Worker update check complete');
    });
  } else {
    // No registration exists, register new service worker
    await navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        console.debug('Service Worker registered', reg);
      })
      .catch((err) => {
        console.warn('Service Worker registration failed', err);
      });
  }
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.action === 'reload') {
      console.debug('Reloading page due to service worker update');
      window.location.reload();
    }
  });
};

if ('serviceWorker' in navigator) {
  registerServiceWorker();
}
